<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import { mapActions, mapState } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Activities",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, Multiselect },
  data() {
    return {
      tableData: [],
      title: "pages.activities.activity",
      user: {}, 
      isLoading: false,
      logData: {},
      pageOfItems: [],
      page: 1,
      firstPage: 1,
      lastPage: null,
      currentPage: null,
      pageOptions: [5, 10, 25],
      perPage: 10,
      showModal: false,
      modalTitle: "Filtres",
      option: [],
      event: [],
      userArray: [],
      showInputEvent: false,
      showInputDescription: false,
      showInputUser: false,
      showInputDate: false,
      lastItem: null,
      filter: {
        event: "",
        events: [],
        description: "",
        user: "",
        users: [],
        date_from: "",
        date_to: "",
      },
      events: [],
    };
  },
  computed: {
    ...mapState({
      logs: (state) => state.log.logs,
    }),
    options() {
      return [
        { id: 1, label: this.$t("pages.logs.table.event") },
        { id: 2, label: this.$t("pages.logs.table.description") },
        { id: 3, label: this.$t("pages.logs.table.user") },
        { id: 4, label: "Date" },
      ];
    },
    users: function () {
      return this.$store.state.user.users.map((user) => {
          return {
            id: user.id,
            fullname: user.firstname + " " + user.lastname
          }
      });
    },
  },

  watch: {
    perPage: function () {
      this.isLoading = false;
      const obj = {
        perPage: this.perPage,
        page: this.page,
      };
      this.onChangePage(obj);
    },

    option: function () {
      if (this.option[this.option.length - 1] === undefined) {
        this.showInputDescription = false;
        this.showInputEvent = false;
      } else {
        if (
          this.option[this.option.length - 1].label ===
          this.$t("pages.logs.table.event")
        ) {
          this.showInputEvent = true;
        }
        if (
          this.option[this.option.length - 1].label ===
          this.$t("pages.logs.table.description")
        ) {
          this.showInputDescription = true;
        }
        if (
          this.option[this.option.length - 1].label ===
          this.$t("pages.logs.table.user")
        ) {
          this.showInputUser = true;
        }
        if (this.option[this.option.length - 1].label === "Date") {
          this.showInputDate = true;
        }
      }
    },
  },
  mounted() {
    // Set the initial number of items
    // this.totalRows = this.items.length;
  },
  methods: {
    ...mapActions(["getLogs"]),

    onSubmit() {
      this.page = 1;
      if (this.filter.date_to !== "") {
        let date_to = new Date(this.filter.date_to);
        let date_to_format =
          date_to.getFullYear() +
          "-" +
          0 +
          (date_to.getMonth() + 1) +
          "-" +
          0 +
          (date_to.getDate() + 1);
        this.filter.date_to = date_to_format;
      }
      const obj = {
        perPage: this.perPage,
        page: this.page,
        filterBy: this.filter,
      };

      this.onChangePage(obj);
      this.closeFilterModal();
    },
    onChangePage(obj) {
      this.getLogs(obj)
        .then((response) => {
          if (response.status == 200) {
            this.logData = response.data.data;
            this.lastPage = response.data.lastPage;
            this.currentPage = response.data.currentPage;
            this.isLoading = false;
          } else {
            this.isLoading = false;
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    showFilterModal() {
      this.showModal = true;
    },
    closeFilterModal() {
      this.showModal = false;
    },
    onChange() {
      this.options.forEach((opts) => {
        const exist = this.option.some((opt) => opt.label === opts.label);
        if (!exist) {
          if (opts.label === this.$t("pages.logs.table.event")) {
            this.showInputEvent = false;
            this.filter.event = "";
          }
          if (opts.label === this.$t("pages.logs.table.description")) {
            this.showInputDescription = false;
            this.filter.description = "";
          }
          if (opts.label === this.$t("pages.logs.table.user")) {
            this.showInputUser = false;
            this.filter.user = "";
          }
          if (opts.label === "Date") {
            this.showInputDate = false;
            this.filter.date_to = "";
            this.filter.date_from = "";
          }
        }
      });
    },
    prevPage() {
      if (this.currentPage > this.firstPage) {
        this.page--;
        const obj = {
          perPage: this.perPage,
          page: this.page,
          filterBy: this.filter,
        };
        this.onChangePage(obj);
      }
      this.isLoading = false;
    },

    nextPage() {
      if (this.currentPage < this.lastPage) {
        this.page++;
        const obj = {
          perPage: this.perPage,
          page: this.page,
          filterBy: this.filter,
        };
        this.onChangePage(obj);
      }
      if (this.page > this.lastPage) {
        this.page--;
      }
      this.isLoading = false;
    },
  },

  created() {
    const obj = {
      perPage: this.perPage,
      page: this.page,
      filterBy: this.filter,
    };
    this.onChangePage(obj);
    this.$store.dispatch("getUsers");
    this.$store.dispatch("logsGrouped").then((response) => {
      this.events = Object.keys(response.data);
    });
  },
};
</script>
<style lang="scss" scoped>
.table-row {
  cursor: pointer;
  .card-drop {
    visibility: hidden;
  }
  &:hover {
    & .card-drop {
      visibility: visible;
      align-self: center;
    }
  }
}

a:hover {
  cursor: pointer;
}
</style>
+
<template>
  <Layout>
    <div class="row mb-3">
      <div class="col">
       <h4 class="d-inline"> {{ $t('pages.activities.activity') }}</h4>
       <button
          class="btn btn-primary ml-3 float-right"
          @click="showFilterModal"
        >
          <b>{{ $t("pages.activities.filter.title") }}</b>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="row">
        <!-- Search -->
        <div class="col-sm-12 col-md-6">
          <div
            id="tickets-table_filter"
            class="dataTables_filter text-md-right"
          >
            <label class="d-inline-flex align-items-center">
              <!-- <b-form-input
                type="search"
                :placeholder="$t('pages.activities.search')"
                class="form-control form-control-sm ml-2"
              ></b-form-input> -->
              
              <b-modal
                id="modal-lg"
                v-model="showModal"
                centered
                size="lg"
                :title="modalTitle"
                title-class="font-18"
                hide-footer
              >
                <form @submit.prevent="onSubmit">
                  <div class="row">
                    <div class="col">
                      <label
                        >{{ $t("pages.activities.filter.subTitle") }} :
                      </label>
                      <multiselect
                        v-model="option"
                        :options="options"
                        :multiple="true"
                        :tage-placeholder="
                          $t('pages.documentType.search')
                        "
                        :placeholder="$t('pages.documentType.tag')"
                        label="label"
                        track-by="id"
                        :taggable="true"
                        @input="onChange"
                      ></multiselect>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-12" v-if="showInputEvent">
                      <label for="">{{
                        $t("pages.logs.table.event")
                      }}</label>
                      <multiselect
                        v-model="filter.events"
                        :options="events"
                        :multiple="true"
                        :tage-placeholder="
                          $t('pages.documentType.search')
                        "
                        :placeholder="$t('pages.documentType.tag')"
                        :taggable="true"
                        @input="onChange"
                      ></multiselect>
                    </div>
                    <div class="col mt-3" v-if="showInputUser">
                      <label for="">{{
                        $t("pages.logs.table.user")
                      }}</label>
                      <multiselect
                        v-model="filter.users"
                        :options="users"
                        :multiple="true"
                        :tage-placeholder="
                          $t('pages.documentType.search')
                        "
                        label="fullname"
                        track-by="id"
                        :placeholder="$t('pages.documentType.tag')"
                        :taggable="true"
                        @input="onChange"
                      ></multiselect>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-6" v-if="showInputDescription">
                      <label for="">{{
                        $t("pages.logs.table.description")
                      }}</label>
                      <textarea class="form-control" v-model="filter.description" id="" cols="30" rows="3"></textarea>
                    </div>
                    <div class="col-12 mt-4" v-if="showInputDate">
                      <label for="">Date</label>
                      <div class="row">
                        <div class="col-6">
                          <input
                            type="date"
                            v-model="filter.date_from"
                            name=""
                            id=""
                            class="form-control"
                          />
                        </div>
                        <div class="col-6">
                          <input
                            type="date"
                            name=""
                            v-model="filter.date_to"
                            id=""
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col">
                      <button class="btn btn-primary float-right">
                        {{ $t("pages.activities.filter.title") }}
                      </button>
                    </div>
                  </div>
                </form>
              </b-modal>
            </label>
          </div>
        </div>
        <!-- End search -->
      </div>

      <div v-if="isLoading">
        <b-skeleton-table
          :rows="12"
          :columns="4"
          :table-props="{ bordered: true, striped: true }"
        ></b-skeleton-table>
      </div>
      <!-- Table -->
      <div class="table-responsive mb-0">
        <div v-if="false" class="mt-2">
          <b-skeleton-table :rows="9" :columns="3"></b-skeleton-table>
        </div>
        <table class="table table-hover mt-2 d-none d-lg-table" v-else-if="true">
          <thead class="thead-light">
            <tr>
              <th class="text-left">
                {{ $t("pages.logs.table.event") }}
              </th>
              <th class="text-left">
                {{ $t("pages.logs.table.description") }}
              </th>
              <th class="text-left">
                {{ $t("pages.logs.table.user") }}
              </th>
              <th class="text-left">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="log in logs" :key="log.id">
              <td v-if="log.type == 'dir'">
                {{ $t(`pages.logs.folder.${log.event}`) }}
              </td>
              <td v-else-if="log.type == 'file'">
                {{ $t(`pages.logs.file.${log.event}`) }}
              </td>
              <td v-else>
                {{ $t(`pages.logs.connexion.${log.event}`) }}
              </td>
              <td v-if="log.type == 'sys'">-</td>
              <td v-else>{{ log.description }}</td>
              <td>{{ log.user }}</td>
              <td>
                {{ $d(new Date(log.date), "short") }}
              </td>
            </tr>
          </tbody>
          <tfoot></tfoot>
        </table>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 d-block d-lg-none" v-for="log in logs" :key="log.id">
          <b-card class="mx-2 border">
            <b-card-title v-if="log.type == 'dir'">
              {{ $t(`pages.logs.folder.${log.event}`) }}
            </b-card-title>
            <b-card-title v-else-if="log.type == 'file'">
              {{ $t(`pages.logs.file.${log.event}`) }}
            </b-card-title>
            <b-card-title v-else>
              {{ $t(`pages.logs.connexion.${log.event}`) }}
            </b-card-title>

            <b-card-text v-if="log.type == 'sys'">-</b-card-text>
            <b-card-text v-else>{{ log.description }}</b-card-text>

            <b-card-text class="small text-muted">{{ log.user }} • {{ $d(new Date(log.date), "short") }}</b-card-text>
          </b-card>
        </div>
      </div>

      <div class="my-4" style="width: 100%;">
        <ul
          class="
            pagination pagination-md
            justify-content-center
            text-center
          "
        >
          <li class="page-item">
            <a class="page-link" @click="prevPage">
              {{ $t(`pages.logs.pagination.prev`) }}</a
            >
          </li>
          <li class="page-link" style="background-color: inherit">
            {{ currentPage }} {{ $t(`pages.logs.pagination.of`) }}
            {{ lastPage }}
          </li>
          <li class="page-item">
            <a class="page-link" @click="nextPage">{{
              $t(`pages.logs.pagination.next`)
            }}</a>
          </li>
        </ul>
      </div>
  </div>
  </Layout>
</template>